export default {
  name: 'LabelTooltip',
  props: {
    code: {
      default: '',
      type: String
    },
    itemClass: {
      default: '',
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    componentName: {
      type: String,
      default: 'label'
    }
  },
  computed: {
    tooltip () {
      if (this.$i18n.locale && this.code) {
        return this.$store.getters.getTranslationTooltip(this.code, this.$i18n.locale);
      }
      return null;
    }
  }
}
